/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Organizerfollowqrpreview3Inputs */

const en_organizerfollowqrpreview3 = /** @type {(inputs: Organizerfollowqrpreview3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Print the flyer in ${i?.size}`)
};

const de_organizerfollowqrpreview3 = /** @type {(inputs: Organizerfollowqrpreview3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Flyer in ${i?.size} drucken`)
};

/**
* | output |
* | --- |
* | "Print the flyer in {size}" |
*
* @param {Organizerfollowqrpreview3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowqrpreview3 = /** @type {((inputs: Organizerfollowqrpreview3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowqrpreview3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowqrpreview3(inputs)
	return de_organizerfollowqrpreview3(inputs)
});
export { organizerfollowqrpreview3 as "organizerFollowQrPreview" }